import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { pendingUsersFetchAction } from '../../../../store/fetchActions/pendingUsersActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import TextInput from '../../../../components/TextInput/TextInput';
import { userFetchAction } from '../../../../store/fetchActions/usersActions';
import { perfisFetchAction } from '../../../../store/fetchActions/perfisActions';
import { approveUserFetchAction } from '../../../../store/fetchActions/approveUserActions';
import Modal from '../../../../components/Modal/Modal';
import { MdErrorOutline } from 'react-icons/md';
import Information from '../../../../components/Information/Information';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import ReadImages from '../../../../components/ReadImages/ReadImages';
import { HiOutlineCheckCircle } from 'react-icons/hi';
import { ImSearch } from 'react-icons/im';
import Button from '../../../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { theme } from '../../../../styles/theme';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';
import formatCEP from '../../../../utils/functions/formatCEP';
import formatPhoneNumber from '../../../../utils/functions/formatPhoneNumber';
import { denyUserFetchAction } from '../../../../store/fetchActions/denyUserActions';
import { CircularProgress } from '@material-ui/core';
import {
  ButtonContainer,
  LoadingContainer,
  SectionTitle,
  SmallerModal,
} from '../../styles/GerenciarClientes.styles';
import { translateMessage } from '../../../../utils/functions/translateMessage';
import DateInput from '../../../../components/DateInput/DateInput';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../../../components/Filter/Filter.styles';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import { showAlert } from '../../../../store/ducks/sweetAlert';
import { cobansFetchAction } from '../../../../store/fetchActions/cobansActions';

const {
  mainColor,
  mainColorButtonHover,
  secondaryColor,
  rbmWhite,
  dangerColor,
  rbmBlack,
  warningColor,
} = theme.colors;

function UsuariosPendentes({ value, index }) {
  const dispatch = useDispatch();
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [isModalDenyOpen, setIsModalDenyOpen] = useState(false);
  const [filterData, setFilterData] = useState('');
  const [userID, setUserID] = useState();
  const { handleSubmit, control, reset } = useForm({});
  const {
    handleSubmit: handleSubmitApproval,
    control: controlAproval,
    reset: resetAproval,
  } = useForm({});

  const [filter, setFilter] = useState({
    search: '',
    DATAINICIAL: '',
    DATAFINAL: '',
    limit: 10,
    page: 1,
  });
  useCallFilter(filterData, setFilter, pendingUsersFetchAction, value, index);
  const filterTable = (data) => {
    setFilterData(data);
  };
  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];
  const { cobansData } = useSelector((state) => state.cobans);
  const { usersData, loadingUser, errorUser, errorMessageUser } = useSelector(
    (state) => state.user,
  );
  const { loadingApproveUser } = useSelector((state) => state.approveUser);
  const infoData = [
    usersData?.CPFCNPJ?.length === 11
      ? { name: 'CPF', value: formatCPF(usersData.CPFCNPJ) }
      : { name: 'CNPJ', value: formatCNPJ(usersData.CPFCNPJ) },
    { name: 'Nome', value: usersData.NOME || '-----' },
    { name: 'E-mail', value: usersData.EMAIL || '-----' },
    { name: 'Data de Nascimento', value: usersData.NASCIMENTO || '-----' },
    {
      name: 'Telefone',
      value: formatPhoneNumber(usersData.TELEFONE) || '-----',
    },
    { name: 'CEP', value: formatCEP(usersData.CEP) || '-----' },
    { name: 'Endereço', value: usersData.ENDERECO || '-----' },
    { name: 'Bairro', value: usersData.BAIRRO || '-----' },
    { name: 'Complemento', value: usersData.COMPLEMENTO || '-----' },
    { name: 'Cidade', value: usersData.CIDADE || '-----' },
    { name: 'UF', value: usersData.UF || '-----' },
    {
      name: 'Renda Mensal',
      value: 'R$ ' + formatMoney(usersData.SALARIO) || '-----',
    },
    { name: 'Matrícula', value: usersData.MATRICULA || '-----' },
    { name: 'Empresa', value: usersData.EMPRESATRABALHA || '-----' },
  ];

  const imagesModal = usersData.DOCUMENTOS?.map((image) => {
    return {
      data: {
        description: image.DESCRICAO_CATEGORIA,
        image: `${image.CAMINHO_ARQUIVO}`,
      },
    };
  });

  useEffect(() => {
    value === index && (() => dispatch(pendingUsersFetchAction(filter)))();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, value, index, filter.page]);
  const {
    pendingUsersData,
    pagination,
    loadingPendingUsers,
    errorPendingUsers,
    errorMessagePendingUsers,
  } = useSelector((state) => state.pendingUsers);

  const closeModals = () => {
    closeModalInfo();
    closeModalDeny();
  };
  const openModalDeny = () => setIsModalDenyOpen(true);
  const closeModalDeny = () => {
    setIsModalDenyOpen(false);
    reset();
  };
  const closeModalInfo = () => setIsModalInfoOpen(false);
  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    { id: 'CPFCNPJ', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
  ];
  const body = pendingUsersData?.map((user) => {
    return {
      data: [
        { info: user.DATA_INSERT, align: 'center' },
        {
          info:
            user.CPFCNPJ?.length === 11
              ? formatCPF(user.CPFCNPJ)
              : formatCNPJ(user.CPFCNPJ),
          align: 'left',
        },
        { info: user.NOME, align: 'left' },
      ],
      onClick: () => inspectUser(user.CPFCNPJ),
    };
  });

  function inspectUser(id) {
    setUserID(id);
    dispatch(userFetchAction(id));
    dispatch(cobansFetchAction());
    setIsModalInfoOpen(true);
  }
  const submitApprovation = (data) =>
    data.perfil ? approveUser(data) : approveError();
  const approveError = () => {
    dispatch(
      showAlert({
        title: 'Ops...',
        text: 'Por favor selecione um perfil',
        icon: 'error',
      }),
    );
  };
  const approveUser = (data) => {
    const param = { CPFUSUARIO: userID, ID_COBAN: data.perfil };
    dispatch(approveUserFetchAction(param, closeModalInfo));
  };
  const submitDenyForm = (data) => {
    const param = { CPFUSUARIO: userID, ERRO_STATUS: data.justificativa };
    dispatch(denyUserFetchAction(param, closeModals));
  };

  return (
    <div hidden={value !== index}>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextInput
              label="Nome ou CPF/CNPJ"
              name={'search'}
              width={'38.042vw'}
              margin={'0 0 0 1.369vw'}
              control={control}
              inputProps={{ role: 'filter-text-input' }}
            />
            <DateInput
              label="Data de Início"
              name={'DATAINICIAL'}
              control={control}
            />
            <DateInput
              label="Data Final"
              name={'DATAFINAL'}
              control={control}
            />

            <Button
              backgroundColor={mainColorButtonHover}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverBGColor={mainColor}
              hoverColor={rbmBlack}
              color={'white'}
              type="submit"
              roleName={'button-buscar-pendentes'}
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>
          <SecondFilterLine>
            <h5>Resultados por Página</h5>
            <SelectOptions
              control={control}
              options={pagesOptions}
              name={'limit'}
              margin={'0 0 0 1.875vw'}
              initialValue={10}
              initialName={10}
            />
            <h5>Total de Registros: {pagination?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>
      {loadingPendingUsers ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          error={errorPendingUsers}
          hasPagination={true}
          filter={filter}
          pagination={pagination}
          setFilter={setFilter}
          errorMessage={errorMessagePendingUsers}
          filterTable={filterTable}
          header={header}
          body={body}
          limit={filter.limit}
        />
      )}

      <Modal
        open={isModalInfoOpen}
        close={closeModalInfo}
        title="Dados do Cliente"
        width={'39.889vw'}
      >
        {loadingUser || loadingApproveUser ? (
          <LoadingContainer marginTop={'1vw'}>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : errorUser ? (
          <h1>{translateMessage(errorMessageUser)}</h1>
        ) : (
          <div role="modal-dados-cliente">
            <Information title="Informações Pessoais" data={infoData} />
            <ReadImages
              title="Documentos Pessoais"
              images={imagesModal}
              imagesMaxWidth={'17vw'}
            />
            <form onSubmit={handleSubmitApproval(submitApprovation)}>
              <SectionTitle>Perfil Associado</SectionTitle>
              <SelectOptions
                control={controlAproval}
                options={cobansData}
                name={'perfil'}
                width="35.111vw"
                label={'Perfil'}
              />
              <Button
                backgroundColor={secondaryColor}
                width="35.111vw"
                height="3.125vw"
                hoverBGColor={mainColor}
                hoverColor={rbmBlack}
                color={'white'}
                type="submit"
                margin={'2.083vw 0 0 0'}
                roleName={'button-aprovar-pendentes'}
              >
                <HiOutlineCheckCircle class="default_svg" size={'1.181vw'} />
                <span>Aprovar</span>
              </Button>
              <Button
                backgroundColor={rbmWhite}
                width="35.111vw"
                height="3.125vw"
                hoverBGColor={dangerColor}
                hoverColor={rbmWhite}
                color={rbmBlack}
                onClick={openModalDeny}
                margin={'0.694vw 0 2.083vw 0'}
                roleName={'button-negar-pendentes'}
              >
                <HiOutlineCheckCircle class="default_svg" size={'1.181vw'} />
                <span>Negar</span>
              </Button>
            </form>
          </div>
        )}
      </Modal>
      <Modal open={isModalDenyOpen} close={closeModalDeny}>
        <SmallerModal>
          <MdErrorOutline color={warningColor} size={'6.944vw'} />
          <h3>Negar Cliente</h3>
          <h5>Tem certeza que deseja negar o cliente?</h5>
          <h4>Justificativa</h4>
          <form onSubmit={handleSubmit(submitDenyForm)}>
            <TextInput
              margin={'0'}
              variant={'outlined'}
              name={'justificativa'}
              width={'28.342vw'}
              multiline={true}
              minRows={3}
              required={true}
              size="large"
              control={control}
              inputProps={{ maxLength: 100 }}
            />
            <ButtonContainer>
              <Button
                backgroundColor={rbmWhite}
                width={'13.792vw'}
                height={'3.125vw'}
                hoverBGColor={secondaryColor}
                hoverColor={rbmWhite}
                color={secondaryColor}
                onClick={() => {
                  closeModalDeny();
                }}
              >
                <span>Voltar</span>
              </Button>
              <Button
                backgroundColor={secondaryColor}
                width={'13.792vw'}
                height={'3.125vw'}
                hoverBGColor={dangerColor}
                hoverColor={rbmWhite}
                color={rbmWhite}
                type="submit"
                roleName={'button-confirmar-negar'}
              >
                <span>Negar</span>
              </Button>
            </ButtonContainer>
          </form>
        </SmallerModal>
      </Modal>
    </div>
  );
}

UsuariosPendentes.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default memo(UsuariosPendentes);
